module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAiCAYAAACnSgJKAAAABHNCSVQICAgIfAhkiAAAARBJREFUWEftV9ENgjAQfY2DqBMYJ1AnED5NMHEFJtARHIEE/C4jOAIj6AZucDZEBCrmrgRMTNrfe73Xe72XXhW4ddEHkDoa2IyDiuKEB5RKEG1jxW7I9A1QUxbnCpjQXECek2teEZ5o82fkUcAfuKv0VF/NXa/eoV6Ve3JRVzVAnbLXPgaIYuzDvJU3s7p9UNnbPi4QBcsfkjOVjVu5J3/dtN1QXvbKAsNazTecbzjrvfZWc31COXw5yXCy2nEuqTQuIk91YWavhTSnGFeOzlzlqV6bhOfhDkB3EBIztJx4cnEp7kBPXmvW99VyVx2fsvdI0trS+IVyqYYnrxiNlbALzQ/3+1IY0ccS8tF8zMn+BKuoDaqfIA+JAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pdf_icon.png
// module id = SeI4
// module chunks = 252